import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import ConnectedFormControl from '../FormControl/FormControl.js';
import { isText } from '../Util/validations.js';

const MiddleName = (_param)=> {
    var { label , errorMessage , validations =[
        isText
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(ConnectedFormControl, swcHelpers.extends({}, ConnectedFormControl.defaultProps, {
        id: "middleName",
        "data-t": "middle-name",
        label: label,
        errorMessage: errorMessage
    }, rest));
};

export { MiddleName as default };
//# sourceMappingURL=MiddleName.js.map
